








































































import {Component, Inject, Prop, Vue} from 'vue-property-decorator';
import {Item} from '@/models/PlanModel';

@Component
export default class PlanBodyActions extends Vue {
    @Prop() item!: Item;
    @Inject() inSearch!: boolean;
}
